import { render, staticRenderFns } from "./LinksDialog.vue?vue&type=template&id=5815817f&scoped=true&"
import script from "./LinksDialog.vue?vue&type=script&lang=js&"
export * from "./LinksDialog.vue?vue&type=script&lang=js&"
import style0 from "./LinksDialog.vue?vue&type=style&index=0&id=5815817f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5815817f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/source/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5815817f')) {
      api.createRecord('5815817f', component.options)
    } else {
      api.reload('5815817f', component.options)
    }
    module.hot.accept("./LinksDialog.vue?vue&type=template&id=5815817f&scoped=true&", function () {
      api.rerender('5815817f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/network-sites/LinksDialog.vue"
export default component.exports